<script setup>
//TODO Remove api use data from shops page
const route = useRoute();
const config = useRuntimeConfig()
const url = config.public.apiBase + '/shop/' + route.params.id;
const { data, status, error } = await useLazyFetch(url);
const shop = computed(() => data.value?.data || {})
</script>
<template>
   <div>
    <div v-if="status === 'pending'">
      <NavLoading />
    </div>

    <div v-else-if="error">
      Failed to load: {{ error.message }}
    </div>

    <div v-else>
    <ShopHeader 
      :id="shop.id"
      :key="shop.id"
      :type="shop.shop_type"
      :name="shop.name"
      :address="shop.address"
      :banner-url="shop.banner?.[0]?.original_url"
      :open-time="shop.opening_time"
      :close-time="shop.closing_time"/>
    <ShopProductTab />
    </div>
  </div>
</template>
